module.exports = __webpack_public_path__ + "img/center20.d61f9122.png";